import React from 'react';
import { number } from 'prop-types';
import getSymbolFromCurrency from 'currency-symbol-map';

/**
 * @param {import('prop-types').InferProps<ProductCompareAtPriceProps>} props
 */
const ProductCompareAtPrice = ({ compareAtPrice, price, storeCurrency }) => {
    return (
        <span>
            <span>{' '}</span>
            <span
                className={'text-decoration-line-through'}>{getSymbolFromCurrency(storeCurrency)}{(compareAtPrice).toFixed(2)} {storeCurrency}</span>
            <div
                className={'mt-3 text-success'}>
                <b>Save</b> <span> {getSymbolFromCurrency(storeCurrency)}{(compareAtPrice - price).toFixed(2)} {storeCurrency}</span>
            </div>
        </span>
    );
};

const ProductCompareAtPriceProps = {
    compareAtPrice: number.isRequired,
    price: number.isRequired,
    storeCurrency: number.isRequired,
};
ProductCompareAtPrice.propTypes = ProductCompareAtPriceProps;
export default ProductCompareAtPrice;